export default {
	search: {
		placeholder: "Recherchez dans notre catalogue",
	},

	account: {
		myOrders: "Mes commandes",
		logOut: "Déconnexion"
	},

	home: {
		catalog: {
			title: "NOUVEAUTÉS",
			seeMore: "TOUT NOTRE CATALOGUE",
		},

		saleProducts: {
			title: {
				past: "LES DERNIÈRES PROMOTIONS",
				active: "NOS PROMOTIONS",
				future: "LES PROCHAINES PROMOTIONS",
			},
			seeMore: "NOS PROMOTIONS",
		},
	},

	catalog: {
		metas: {
			title: "Notre catalogue de produits",
			description: "Consultez notre catalogue complet de produits."
		},


		seeMore: "VOIR PLUS",
		productsleft: number => `${number} produit${number > 1 ? "s" : ""}`,
		allCategories: "TOUS NOS PRODUITS",
		empty: "Aucun produit n'a été trouvé."
	},

	shop: {
		title: "NOTRE BOUTIQUE",
		socialNetworks: "Suivez-nous et restez informé de toutes nos opérations",
		contact: {
			label: "Vous souhaitez en savoir plus sur nos produits et notre boutique ?",
			button: "CONTACTEZ-NOUS",
		},

		comments: {
			title: "COMMENTAIRES DE NOS CLIENTS",
		}
	},

	sale: {
		metas: {
			title: "Nos ventes privées",
			description: "Visualisez la liste complète de nos produits en promotion lors de ventes privées."
		},

		title: {
			future: "NOS PROCHAINES VENTES PRIVÉES",
			active: "NOS VENTES PRIVÉES",
			past: "NOS DERNIÈRES VENTES PRIVÉES",
			default: "NOS VENTES PRIVÉES"
		},
		seeMore: "VOIR PLUS",
		products: "produits",
		salesTitle: "LES VENTES PRIVÉES DE L’ANNÉE",
		noSales: "🤷 La boutique n'a encore fait aucune vente privée.",
		item: {
			from: "Du",
			to: "au",
		},
		saleFinished: "TERMINÉ",
		saleComing: "À VENIR",
	},

	product: {
		meta: {
			title: ({product, prodshop: {finalPrice}}) =>
				`${finalPrice.formatted} ${product.brand} ${product.name}`,

			description: ({product, shop, prodshop: {finalPrice}}) =>
				`Consultez ${product.name} ${product.safeBrand ? "de" + product.brand : ""} à ${finalPrice.formatted} dans la boutique ${shop.name} à ${shop.address.city}.`
		},
		askButton: "Demander cet article",

		sizesTitle: "Tailles disponibles",
		toBeFoundAtShop: "A retrouver dans notre boutique",
		similarProductsTitle: "NOS AUTRES PRODUITS",
	},

	collectionList: {
		meta: {
			title: "Toute nos collections de produits",
			description: (vShopCollections) => {
				vShopCollections = vShopCollections ? vShopCollections.slice(0, 3) : [];
				let collectionsNames = vShopCollections.map(vShopCollection => vShopCollection.collection.title);
				let samples = collectionsNames.join(', ');
				if (collectionsNames.length)
					samples += "... ";

				return samples + "Visualisez toutes les collections que contient notre catalogue."
			}
		},

		seeCollection: "Voir la collection"
	},

	collection: {
		meta: {
			title: collection => `Collection ${collection.title}`,
			description: collection => `Consultez nos produits de la collection ${collection.title}. \n${collection.subtitle}`
		}
	},

	brandList: {
		metas: {
			title: "Toute les marques que nous proposons",
			description: brands => {
				let samples = (brands || []).slice(0, 3).map(brand => brand.name);

				let result = "Consultez toutes les marques de notre catalogue.";
				if (samples.length)
					result = samples.join(", ") + "... " + result;

				return result;
			}
		}
	},

	appFooter: {
		title: "NOUS CONTACTER",
		phone: "Tel. : ",
		schedule: {
			title: "Horaires :",
			closed: "Fermé",
		},
		button: "CONTACTEZ-NOUS",
		legalMention: `©${(new Date).getFullYear()} • Tous droits réservés • Mentions légales`,
	},

	TextExtender: {
		open: "Tout afficher",
		close: "Refermer",
	},

	payment: {
		requiredField: "*Champs obligatoire",
		firstName: "Nom",
		lastName: "Prénom",
		address: "Adresse",
		streetNumber: "Numéro",
		addressStreet: "Rue",
		zipCode: "Code postal",
		city: "Ville",
		country: "Pays",
		phone: "Tél.",
		nationality: "Nationalité",
		email: "Email",
		creditCardNumber: "Numéro CB",
		creditCardNumberPlaceholder: "0123 4567 8910 2655",
		expirationDate: "Date d’expiration",
		expirationDatePlaceholder: "02/26",
		creditCardCVC: "CVC",
		creditCardCVCPlaceholder: "265",
		pay: "payer",
		paymentInProgress: "Paiement en cours...",
		paymentSucceed: "Paiement effectué avec succès",
		seeOrder: "Voir la commande",
		chooseACard: "Choisissez une carte : ",
		chooseInvoice: "Choisissez les infos de facturation : ",
		finish: "Payment terminé",
		successPayment: "bravo,le paiement a été effectué avec succes",
		failedPayment: "Une erreur est survenu lors du paiement",
		needToFillPersonalInfo: "veuillez remplir tout les champs concernant vos informations",
		needToSelectPersonalInfo: "veuillez selectionnez vos informations",
		needToFillBankCardInfo: "veuillez remplir tout les champs concernant votre carte banquaire",
		needToSelectBankCardInfo: "veuillez selectionnez votre carte banquaire",
		addNewBillingInfo: "ajouter de nouvelles infos de facturation",
		useExistingBillingInfo: "utiliser des infos de facturation existantes",
		addNewCard: "ajouter une carte",
		useExistingCard: "utiliser une carte existante",
		remove: "Supprimer",
		infosWasRemoved: "Ces infos ont été supprimé",
		cardWasRemoved: "Cette carte a été supprimé",
		size: "Taille",
		expire: "Expire",
		deal: "Deal",
		sale: "Vente privée",
	},


	fragment: {
		orderList: {
			billNumber: "Facture n°",
			numberOfItems: "nombre de produits",
			state: "statut",
			sum: "total",
			title: "Mes commandes",
			phone: "Tel.",
			noOrder: "Aucune commande",
		},
		payment: {
			errors: {
				title: 'Erreur!',
				loading: 'Une erreur est survenu lors du chargement.',
				validatingInformation: 'Une erreur est survenu lors de la validation de vos informations.',
				loadingCards: 'Une erreur est survenu lors du chargement des cartes.',
				addingCards: 'Une erreur est survenu lors du rajout de la carte',
				onPayment: 'Une erreur est survenu lors du paiement',
			},
			legalInformation: {
				title: 'Informations personnelles',
				firstName: {
					text: 'NOM',
					error: 'Incorrect'
				},
				lastName: {
					text: 'PRENOM',
					error: 'Incorrect'
				},
				nationality: {
					text: 'NATIONALITE',
					error: 'Incorrect'
				},
				birthday: {
					text: 'DATE DE NAISSANCE',
					error: 'Incorrect'
				},
				countryOfResidence: {
					text: 'PAYS',
					error: 'Incorrect'
				},
			},
			cardSelection: {
				title: 'CARTE',
				delete: 'Confirmez-vous bien vouloir effacer les données de cette carte ?'
			},
			addPaymentCard: {
				title: 'Mode de paiement',

				number: {
					text: 'Numero de carte',
					error: 'Incorrect'
				},
				expiration: {
					text: 'Date d’expiration',
					error: 'Incorrect'
				},
				cvv: {
					text: 'CVV',
					error: 'Incorrect'
				},
				address: {
					text: 'Adresse de facturation',
				},
				name: {
					text: 'Titulaire de la carte',
				},
			},
			review:{
				title: 'Vérification',
				subtitle: 'Pour des raisons de sécurité, le règlement de la commande sera independent pour chaque boutique.',
				paymentMode: 'MODE DE PAIEMENT',
				billing: 'FACTURATION',
				legalConditions: {
					title: 'TERMES & CONDITIONS',
					text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Egestas sed tempus urna et pharetra. Elit ullamcorper dignissim cras tincidunt lobortis feugiat vivamus at augue. Faucibus scelerisque eleifend donec pretium vulputate sapien nec sagittis. Massa id neque aliquam vestibulum morbi blandit cursus. Aenean et tortor at risus viverra adipiscing at in tellus. Felis imperdiet proin fermentum leo vel orci porta non. Convallis a cras semper auctor neque vitae tempus quam pellentesque. Vulputate eu scelerisque felis imperdiet proin. Amet mauris commodo quis imperdiet. Viverra suspendisse potenti nullam ac.Ac felis donec et odio pellentesque diam. Laoreet sit amet cursus sit amet. Aliquet nibh praesent tristique magna. Molestie ac feugiat sed lectus vestibulum mattis. Viverra ipsum nunc aliquet bibendum. Cras sed felis eget velit aliquet sagittis id. Ut pharetra sit amet aliquam id diam maecenas ultricies mi. Molestie ac feugiat sed lectus. Faucibus turpis in eu mi bibendum neque egestas congue quisque. Dictum sit amet justo donec enim diam vulputate ut pharetra. Nulla posuere sollicitudin aliquam ultrices sagittis orci a scelerisque. Eu tincidunt tortor aliquam nulla. Porttitor rhoncus dolor purus non enim praesent. Eget velit aliquet sagittis id consectetur purus ut.Aliquam eleifend mi in nulla posuere sollicitudin aliquam. Morbi tristique senectus et netus. Sit amet nulla facilisi morbi tempus iaculis. Aliquam ut porttitor leo a diam sollicitudin tempor. Fringilla ut morbi tincidunt augue interdum velit euismod in. Amet justo donec enim diam. Quisque sagittis purus sit amet volutpat consequat mauris nunc congue. Amet facilisis magna etiam tempor orci eu lobortis. Aliquet eget sit amet tellus. Nunc scelerisque viverra mauris in aliquam sem fringilla ut. Sit amet nisl purus in. Mus mauris vitae ultricies leo integer malesuada nunc vel risus. Cursus sit amet dictum sit amet. Enim nulla aliquet porttitor lacus luctus accumsan. Est ullamcorper eget nulla facilisi etiam dignissim diam quis. Id porta nibh venenatis cras sed felis eget. Donec massa sapien faucibus et molestie ac feugiat sed.At in tellus integer feugiat scelerisque varius. Ac turpis egestas maecenas pharetra convallis posuere morbi leo urna. Turpis in eu mi bibendum neque egestas congue quisque egestas. Nec tincidunt praesent semper feugiat nibh sed pulvinar proin. Tristique magna sit amet purus gravida quis. Platea dictumst vestibulum rhoncus est. Tellus cras adipiscing enim eu turpis egestas pretium aenean. Vestibulum morbi blandit cursus risus at ultrices mi tempus imperdiet. Malesuada proin libero nunc consequat interdum varius sit amet. Vulputate dignissim suspendisse in est ante in nibh mauris cursus. Iaculis nunc sed augue lacus viverra vitae congue eu consequat. Nunc mattis enim ut tellus elementum. Porta lorem mollis aliquam ut porttitor leo a. Viverra nam libero justo laoreet sit amet. Morbi tempus iaculis urna id volutpat. Odio morbi quis commodo odio. Enim sed faucibus turpis in eu mi bibendum. Commodo odio aenean sed adipiscing diam.Mattis enim ut tellus elementum. Quam viverra orci sagittis eu. Lacus viverra vitae congue eu consequat. Nibh cras pulvinar mattis nunc sed. Ultrices eros in cursus turpis massa tincidunt dui ut ornare. Sit amet dictum sit amet justo. Eget nulla facilisi etiam dignissim. Malesuada bibendum arcu vitae elementum curabitur vitae nunc sed velit. Egestas diam in arcu cursus. Elementum eu facilisis sed odio morbi quis commodo odio aenean. Molestie ac feugiat sed lectus vestibulum mattis ullamcorper velit sed. Nulla facilisi nullam vehicula ipsum. A cras semper auctor neque vitae. Neque ornare aenean euismod elementum nisi quis. Amet commodo nulla facilisi nullam vehicula ipsum a arcu cursus. At risus viverra adipiscing at in. Vitae et leo duis ut diam. Ultrices in iaculis nunc sed augue lacus viverra vitae. Bibendum neque egestas congue quisque egestas diam in arcu. Et pharetra pharetra massa massa ultricies.'
				},
			},
			canContinueToChat: 'Vous pouvez suivre vos commandes dans la section “échanges”',
			continueToShopping: 'Continuez votre Shopping',
			confirm: 'confirmer',
			buy: 'acheter',
			continue: 'continuer',
		},
	}
}
